import script from "./ProductPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductPage.vue?vue&type=style&index=0&id=6913f368&scoped=true&lang=css"
script.__scopeId = "data-v-6913f368"

export default script